import { NumberField as RaNumberField, NumberFieldProps as RaNumberFieldProps } from 'react-admin';

export const NumberField = RaNumberField;

export type NumberFieldProps = RaNumberFieldProps;
